import { render, staticRenderFns } from "./Medikamentenblatt.vue?vue&type=template&id=7139f36f&"
import script from "./Medikamentenblatt.vue?vue&type=script&lang=js&"
export * from "./Medikamentenblatt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports